import { useState } from "react";
import { useNavigate } from "react-router";
import type { UserProfile } from "@/services/auth";
import { signOut } from "@/services/auth";

export function UserMenu({ user }: { user: UserProfile }) {
  const navigate = useNavigate();
  const [pending, setPending] = useState(false);

  async function onSignOut() {
    setPending(true);
    await signOut();
    // `replace` so the back button cannot return to a page the session is gone
    // from, and a full reload so no loader data outlives the session.
    await navigate("/login", { replace: true });
    window.location.reload();
  }

  return (
    <div className="flex items-center gap-3">
      <div className="text-right leading-tight">
        <div className="text-xs font-medium text-ink">{user.name}</div>
        <div className="text-[0.6875rem] text-ink-faint">{user.email}</div>
      </div>
      <button
        type="button"
        disabled={pending}
        onClick={() => void onSignOut()}
        className="rounded-md border border-line px-2 py-1 text-xs text-ink-muted transition-colors hover:bg-surface-sunken hover:text-ink"
      >
        {pending ? "Signing out…" : "Sign out"}
      </button>
    </div>
  );
}
